import React from "react";
import styled from "styled-components";
import { SkinId } from "../../../skins/types";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { riotProductSkin } from "../skins/riot-product";
import { isValidDate, isBetween } from "../../../functional/dateUtils";
const StylableDateInput = ({ className, minDate, maxDate, onValueChange, name, value, ...props }) => {
    const [valid, setValid] = React.useState(false);
    const handleValidation = (event) => {
        const dateValue = event.target.value;
        const validDate = isValidDate(dateValue) && isBetween(dateValue, minDate, maxDate);
        setValid(validDate);
        onValueChange?.(dateValue);
    };
    return (React.createElement("div", { className: className },
        React.createElement("input", { ...props, type: "date", name: name, maxLength: 8, "data-valid": valid, onChange: handleValidation, max: "9999-12-31", value: value })));
};
StylableDateInput.defaultProps = {
    "data-testid": "date-input",
};
export const DateInput = styled(StylableDateInput) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=DateInput.js.map